/* eslint-disable @next/next/no-img-element */
import { CinemaList } from '@/components/screen'
import { handleSortCinemas, toggleLanguage } from '@/helper/functions'

import Link from 'next/link'
// import { Select } from 'antd'
import { useWindowSize } from '@/hooks/userWindowSize'
import Image from 'next/image'
import { FC, useEffect } from 'react'
import { SwiperProps } from 'swiper/react'
import { getHeightElement } from '@/utils/GetHeightElement'

type TProps = {
  data: any
}

export const config: SwiperProps = {
  speed: 1200,
  initialSlide: 0,
  centeredSlides: false,
  loop: false,
  spaceBetween: 0,
  effect: 'slide',
  slidesPerView: 'auto',
  autoplay: true,
}

export const BookTicketByTheaterPage: FC<TProps> = ({ data }: any) => {
  const { isDesktop, isTablet, width } = useWindowSize()

  useEffect(() => {
    getHeightElement();
  }, [isDesktop])
  if (width == 0) return null
  return (
   <>
    {/* {!isDesktop && !isTablet && <SelectTheaterMobile isHideTitle idItems={router.asPath.split("/").at(-2)}/>} */}
    <section className="booking-cinestar">
      <div className="container">
        <div className="booking-cinestar-wr">

            {/* <div className="booking-cinestar-heading sec-heading" data-aos="fade-up">
            <div className="heading">
              <h1>Chọn rạp gần bạn</h1>
            </div>
            <div className="filter">
              <div className="select-location-second">
                <Select
                  defaultValue={{
                    value: "0",
                    label: "Chọn khu vực"
                  }}
                  className='area-theater'
                  onChange={(e: any) => {
                    setIdArea(e)
                  }}
                  options={dataArea?.map((item: any) => ({
                    value: item?.id,
                    label: toggleLanguage(item, "name"),
                  }))}
                />
              </div>
            </div>
          </div> */}
            {(isDesktop || isTablet) &&
              <div className="loadding-block relative">
                <CinemaList dataCinema={handleSortCinemas(data)} />
              </div>
            }
            {(!isDesktop && !isTablet) &&
              <div className='book-theater'>
                {data?.map((item: any) => {
                  return <Link href={`/book-tickets/${item?.id}`} key={item?.id} className='book-theater-item'>
                    <div className='book-theater-image col-4'><Image width={100} height={100} src={`${item?.image || "/assets/images/img-cinema-rental-1.jpg"}`} alt='Image of cinema' /></div>
                    <div className='book-theater-content'>
                      <h4 className='book-theater-name'>{toggleLanguage(item, "name") || ""}</h4>
                      <div className='book-theater-info'>
                        <span className="book-theater-icon">
                          <img src="/assets/images/ic-branch-map.svg" alt="" /> <span className='txt-address'>{item?.address}</span>
                        </span>
                      </div>
                      <div className='book-theater-info'>
                        <span className="book-theater-icon">
                          <i className="fa-regular fa-phone-volume fa-sm"></i> {item?.telephone}
                        </span>
                      </div>
                    </div>
                  </Link>
                })}
              </div>}
          </div>
        </div>
      </section></>
  )
}